var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('CrudTable',{attrs:{"entity":"OrderDraft","columns":_vm.columns,"on-row-dbl-click":_vm.onTableRowDoubleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }